import { twMerge } from "tailwind-merge";

/**
 * Centered spinner loading indicator.
 * Used for pages that are primarily routing hubs or have minimal layout structure.
 */
export interface SpinnerLoaderProps {
  /** Text displayed below the spinner */
  text?: string;
  /** Spinner border color class (default: border-gray-900) */
  spinnerColor?: string;
  /** Background color class (default: bg-background) */
  bgColor?: string;
  /** Text color class (default: text-gray-600) */
  textColor?: string;
  className?: string;
}

export function SpinnerLoader({
  text = "Loading...",
  spinnerColor = "border-gray-900",
  bgColor = "bg-background",
  textColor = "text-gray-600",
  className,
}: SpinnerLoaderProps) {
  return (
    <div
      className={twMerge(
        "flex items-center justify-center min-h-screen",
        bgColor,
        className
      )}
    >
      <div className="text-center">
        <div
          className={twMerge(
            "animate-spin rounded-full h-8 w-8 border-b-2 mx-auto",
            spinnerColor
          )}
        />
        {text && (
          <p className={twMerge("mt-4 animate-pulse", textColor)}>{text}</p>
        )}
      </div>
    </div>
  );
}
